const emptySuccessFunc = (data) => data;

const emptyFailFunc = (data) => Promise.reject(data);

const interceptorFactory =
  (name, isSuccess = true) =>
  (params) => {
    // @ts-ignore
    const configFunc = window.axiosConfig?.[name];

    if (typeof configFunc === 'function') {
      return configFunc(params);
    }

    const emptyFunc = isSuccess ? emptySuccessFunc : emptyFailFunc;
    return emptyFunc(params);
  };

export const requestSuccessForPrefix = interceptorFactory('requestSuccessForPrefix');

export const requestSuccessForPost = interceptorFactory('requestSuccessForPost');

export const requestFailForPrefix = interceptorFactory('requestFailForPrefix', false);

export const requestFailForPost = interceptorFactory('requestFailForPost', false);

export const responseSuccessForPrefix = interceptorFactory('responseSuccessForPrefix');

export const responseSuccessForPost = interceptorFactory('responseSuccessForPost');

export const responseFailForPrefix = interceptorFactory('responseFailForPrefix', false);

export const responseFailForPost = interceptorFactory('responseFailForPost', false);
